export default {
  name: 'dashify:SingleValueNumber',
  title: 'Single Value Number',
  owner: 'System',
  solution: '',
  tags: ['widget', 'numeric', 'single value'],
  createdAt: 'Aug 20, 2023, 10:14 AM',
  modifiedAt: 'AUG 20, 2023, 2:34 PM',
  spec: {
    props: {
      title: '',
      data: null,
      unit: '',

      shortFormat: false,
      href: '',
      valueTextSize: 'text-2xl',

      backgroundColorClassName: '',
      titleColorClassName: '',
      valueColorClassName: '',
      drillDownHoverColorClassName: 'hover:bg-neutral-200/20',
      alignment: 'LEFT',
      unitColorClassName: '',
    },
    title: '/${ props.title }',
    data: '/${ props.data }',
    unit: '/${ props.unit }',
    shortFormat: '/${ props.shortFormat }',
    href: '/${ props.href }',

    alignmentClassNames: {
      LEFT: 'items-start',
      CENTER: 'items-center',
      RIGHT: 'items-end',
    },
    alignment: '/${ $uppercase(props.alignment) }',
    alignmentClassName: '/${ $lookup(alignmentClassNames, alignment) }',
    backgroundColorClassName: '/${ props.backgroundColorClassName }',
    titleColorClassName: '/${ props.titleColorClassName }',
    valueColorClassName: '/${ props.valueColorClassName }',
    unitColorClassName: '/${ props.unitColorClassName }',

    containerClassName:
      "/${ 'text-sm px-2 mx-0 flex flex-col justify-center ' & backgroundColorClassName & ' ' & alignmentClassName }",
    titleClassName: "/${ 'opacity-80 mb-2 ' & titleColorClassName }",
    valueClassName:
      "/${ 'm-0 flex items-baseline mb-2 ' & valueColorClassName & ' ' & (props.valueTextSize ? props.valueTextSize : 'text-2xl') } ",
    drillDownClassName:
      "{ 'hover:rounded-md hover:text-white/90 transition-colors ease-out duratin-1000 ' & props.drillDownHoverColorClassName }",
    unitClassName: "/${ 'text-sm mx-1 ' & unitColorClassName }",

    view: [
      {
        instanceOf: 'div',
        className: '/${ containerClassName }',
        children: [
          {
            instanceOf: 'p',
            className: '/${ titleClassName }',
            children: '/${ title }',
          },
          {
            instanceOf: 'div',
            className: '/${ valueClassName }',
            children: [
              {
                instanceOf: 'a',
                href: '/${ href }',
                className: '/${ href ? drillDownClassName : "pointer-events-none" }',
                children: [
                  [
                    'dashify:If',
                    { condition: '/${ data = null }' },
                    [
                      ['dashify:Then', {}, [['p', {}, '—']]],
                      ['dashify:Else', {}, [['p', {className: '/${ valueClassName }'}, '/${ shortFormat ? $toNumberShort(data) : data}']]],
                    ],
                  ],
                ],
              },
              {
                instanceOf: 'p',
                className: '/${ unit ? unitClassName : "hidden" }',
                children: '/${ unit }',
              },
            ],
          },
        ],
      },
    ],
  },
};
